import { useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import JoinUs from "./pages/JoinUs";
import TrainingPrograms from "./pages/TrainingPrograms";
import Credit from "./pages/Credit";

export default function App() {
  const [page, setPage] = useState("Home");

  const renderPage = () => {
    switch (page) {
      case "About":
        return <About setPage={setPage} />;
      case "Contact":
        return <Contact setPage={setPage} />;
      case "Join Us":
        return <JoinUs setPage={setPage} />;
      case "Training Programs":
        return <TrainingPrograms setPage={setPage} />;
      case "Credits":
        return <Credit setPage={setPage} />;
      default:
        return <Home setPage={setPage} />;
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
        background: "#fff",
        minHeight: "100vh",
      }}
    >
      <header>
        <Navbar page={page} setPage={setPage} />
      </header>

      <main aria-label="Main Content">
        {renderPage()}
      </main>

      <footer>
        <Footer setPage={setPage} />
      </footer>
    </div>
  );
}